/**
 * This has a specific use case for writing to the contentDocument allowing for a separated scope
 *
 * There are probably other ways to do this with ShadowDom but this works well for my purposes
 *
 * USAGE:
 *
 * <CustomIframe html={<head><title>Doc Title</title></head><body>Hello React User</body>} />
 *
 */

import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

const CustomIframe = forwardRef((props, ref) => {
  const { id, title, allow, style, src, allowFullScreen, frameBorder, onReloadPage } = props;
  const [reloadTime, setReloadTimes] = useState(0);

  const getBrowserFullscreenElementProp = () => {
    if (typeof document.fullscreenElement !== 'undefined') {
      return 'fullscreenElement';
    } if (typeof document.mozFullScreenElement !== 'undefined') {
      return 'mozFullScreenElement';
    } if (typeof document.msFullscreenElement !== 'undefined') {
      return 'msFullscreenElement';
    } if (typeof document.webkitFullscreenElement !== 'undefined') {
      return 'webkitFullscreenElement';
    }
    return null;
  };

  useImperativeHandle(
    ref,
    () => ({
      requestFullScreenMode() {
        const fullscreenMode = getBrowserFullscreenElementProp();
        switch (fullscreenMode) {
          case 'fullscreenElement':
            document.getElementById(id).requestFullscreen();
            break;
          case 'mozFullScreenElement': /* Firefox */
            document.getElementById(id).mozFullScreenElement();
            break;
          case 'msFullscreenElement': /* IE11 */
            document.getElementById(id).msRequestFullscreen();
            break;
          case 'webkitFullscreenElement': /* Safari */
            document.getElementById(id).webkitRequestFullscreen();
            break;
          default:
            throw new Error('fullscreenElement is not supported by this browser');
        }
      },
    }),
  );

  useEffect(() => {

  });

  return (
    <iframe
      id={id}
      title={title}
      allow={allow}
      style={style}
      src={src}
      allowFullScreen={allowFullScreen}
      frameBorder={frameBorder}
      onLoad={event => {
        console.log('event: ', event);
        console.log('reloadTime: ', reloadTime);
        setReloadTimes(reloadTime + 1);
        if (reloadTime > 0) {
          onReloadPage();
        }
      }}
    />
  );
});

CustomIframe.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  allow: PropTypes.string.isRequired,
  style: PropTypes.shape().isRequired,
  src: PropTypes.string.isRequired,
  allowFullScreen: PropTypes.bool.isRequired,
  frameBorder: PropTypes.string.isRequired,
  onReloadPage: PropTypes.func.isRequired,
};

CustomIframe.defaultProps = {};

export default CustomIframe;
